import React from 'react'

// This page is loaded inside the OAuth popup window.
// The parent window polls this page's URL to extract the access_token from the hash fragment.
// Once the parent detects the token, it closes this popup.
const OAuthCallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'white', backgroundColor: '#0f0f0f' }}>
    <p>Completing sign in...</p>
  </div>
)

export default OAuthCallback
